import { useContext, useEffect, useState } from 'react';
import { EntityTypeEnum, LovDTO } from '@api/ringil-api.v2';
import { ApiContext } from '@api/api';

export interface FoldersState {
  /** Folders of the company the user may access (BE-filtered LOV). */
  folders: LovDTO[];
  /** False until the LOV answered - an empty list before that means "unknown", not "no folders". */
  loaded: boolean;
}

/** RD-2977: accessible company folders of one entity type plus whether the LOV has answered yet. */
export const useFoldersState = (entityType: EntityTypeEnum): FoldersState => {
  const [state, setState] = useState<FoldersState>({ folders: [], loaded: false });
  const { lovCompanyFolders } = useContext(ApiContext); // LovDTO

  useEffect(() => {
    const ac = new AbortController();
    lovCompanyFolders(null, entityType, d => {
      if (ac.signal.aborted) return;
      setState({ folders: d ?? [], loaded: true });
    });
    return () => {
      ac.abort();
    };
  }, []);

  return state;
};

const useFolders = (entityType: EntityTypeEnum): LovDTO[] => useFoldersState(entityType).folders;

export default useFolders;
